import { Injectable } from '@angular/core';
import {ServerConnectionService} from "../serverConnection/server-connection.service";
import {BehaviorSubject, interval, Observable, Subject} from "rxjs";
import {CesiumAdapterService} from "../cesiumAdapter21/cesium-adapter.service";
import {throttle} from "rxjs/operators";

const list = {};
const $ = jQuery;

@Injectable({
  providedIn: 'root'
})

export class EditorsListProviderService {

  constructor(private socket: ServerConnectionService, private adapter: CesiumAdapterService) {
    this.initListeners();
  }

  private currentMousePos$ = new Subject<object>();

  private selfId;
  private _list = new BehaviorSubject<any>(null);
  get list():Observable<any>{
    return this._list.asObservable();
  }

  private initListeners(){
    let self = this;
    this.socket.onAction('selfId', function (id) {
      self.selfId = id;
    });
    self.socket.onAction('addUser', function (users) {
        if (users.hasOwnProperty(self.selfId)) {
          delete users[self.selfId];
        }
        for (var i in users) {
          list[i] = users[i];
          list[i].color = self.randomColor(100);
          list[i].trackCursor = true;
          list[i].cursor = jQuery('<div>').addClass('user-cursor').attr('id', 'cursor-' + i)
            .css('background-color', list[i].color);
          jQuery('body').append(list[i].cursor);
          self._list.next(list);
        }
      });

    self.socket.onAction('removeUser', function (id) {
        list[id].cursor.remove();
        delete list[id];
        self._list.next(list);
    });

    self.socket.onAction('mousePosition', function (position) {
      var x = $(document).width() * position.x;
      var y = $(document).height() * position.y;
      if (list.hasOwnProperty(position.sid)) {
        if (!list[position.sid].trackCursor) {
          return;
        }
        var point = self.adapter.cesiumConverter.fromLatLngToWindow(position);
        list[position.sid].cursor.css({
          left: point.x + "px",
          top: point.y + "px"
        });
      }
    });

    self.currentMousePos$.asObservable().pipe(
      throttle(value => interval(500), {trailing: true})
    ).subscribe((value)=>{
      self.socket.emit('mousePosition', value, null, true);
    });

    self.adapter.isEventsHandlerLoaded.subscribe((val)=>{
      if (val){
        let handler = new Cesium.ScreenSpaceEventHandler(self.adapter.viewer.canvas);
        handler.setInputAction(
          function (event) {
            let currentPosition = self.adapter.viewer.scene.pickPosition(event.endPosition);
            if (!currentPosition){
              return;
            }
            let pos = self.adapter.cesiumConverter.convertFromCartesianToCartographic(currentPosition);
            delete pos.z;
            self.currentMousePos$.next(pos);
          }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
      }
    });
  }

  setUserCursorVisibility(visibility, itemId?){
    if (itemId){
      this.setUserItemVisibility(itemId, visibility);
      this._list.next(list);
      return;
    }

    for (let sid in list){
      this.setUserItemVisibility(sid, visibility)
    }
    this._list.next(list);
  }

  private setUserItemVisibility(sid, visibility){
    list[sid].trackCursor = visibility;
    list[sid].cursor.css({
      display: (list[sid].trackCursor) ? 'block' : 'none',
      left: "-100px",
    });
  }

  private randomChannel(brightness){
    var r = 255-brightness;
    var n = 0|((Math.random() * r) + brightness);
    var s = n.toString(16);
    return (s.length==1) ? '0'+s : s;
  }

  private randomColor(brightness){
    return '#' + this.randomChannel(brightness) + this.randomChannel(brightness) + this.randomChannel(brightness);
  }
}
